import React, { useState, useCallback, useEffect } from 'react';
import BlogPostCard from './item-card/BlogPostCard';
import PropTypes from 'prop-types';
import EventCard from './item-card/EventCard';
import ProjectCard from './item-card/ProjectCard';

import debounce from 'lodash/debounce';

const ItemsList = ({ initialItems, cardColumns, secondPage, isMixedLayout }) => {
  const [items, setItems] = useState(initialItems);
  const [nextPagePath, setNextPagePath] = useState(secondPage);

  const loadNextPage = useCallback(async () => {
    if (!nextPagePath) {
      return;
    }
    if (nextPagePath) {
      const url = `/${nextPagePath}`;
      setNextPagePath(null);
      const res = await fetch(url);
      const json = await res.json();
      setItems(state => [...state, ...json.items]);
      setNextPagePath(json.nextPagePath);
    }
  }, [nextPagePath]);

  useEffect(() => {
    window.onscroll = debounce(() => {
      const OFFSET = window.innerHeight;
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - OFFSET
      ) {
        loadNextPage();
      }
    }, 50);
  });
  return (
    <div className={`cards-container ${isMixedLayout ? 'mixed-container': 'grid-container'}`}>
      {items &&
        items.map(({ node: item }, i) => {
          let skipThumbnail = false;
          if (isMixedLayout && i) {
            skipThumbnail = true;
          }
          const type = item.frontmatter.templateKey;
          switch (type) {
            case 'blog-post':
              return (
                <BlogPostCard
                  key={item.id}
                  id={item.id}
                  slug={item.fields.slug}
                  title={item.frontmatter.title}
                  publicationDate={item.frontmatter.date}
                  isFeatured={item.frontmatter.featuredpost}
                  featuredImage={item.frontmatter.featuredimage}
                  summary={item.frontmatter.summary}
                  authors={item.frontmatter.authors}
                  timeToRead={item.timeToRead}
                  language={item.frontmatter.language}
                  cardColumns={cardColumns}
                  skipThumbnail={skipThumbnail}
                />
              );
            case 'event':
              return (
                <EventCard
                  key={item.id}
                  id={item.id}
                  slug={item.fields.slug}
                  title={item.frontmatter.title}
                  eventDate={
                    item.frontmatter.dateRange
                      ? item.frontmatter.dateRange
                      : item.frontmatter.date
                  }
                  location={item.frontmatter.location}
                  isFeatured={item.frontmatter.featuredpost}
                  featuredImage={item.frontmatter.featuredimage}
                  speakers={item.frontmatter.speakers}
                  summary={item.frontmatter.summary}
                  cardColumns={cardColumns}
                  skipThumbnail={skipThumbnail}
                />
              );
            case 'project':
              return (
                <ProjectCard
                  key={item.id}
                  id={item.id}
                  title={item.frontmatter.title}
                  githubRepo={item.frontmatter.github}
                  isFeatured={item.frontmatter.featuredpost}
                  featuredImage={item.frontmatter.featuredimage}
                  summary={item.frontmatter.summary}
                  website={item.frontmatter.website}
                  cardColumns={cardColumns}
                  skipThumbnail={skipThumbnail}
                />
              );
            default:
              return null;
          }
        })}
    </div>
  );
};

ItemsList.propTypes = {
  initialItems: PropTypes.array,
  cardColumns: PropTypes.number,
  secondPage: PropTypes.string,
  isMixedLayout: PropTypes.bool,
};

export default ItemsList;
